import React, { Component } from 'react';
import { Modal, Spin } from 'antd';


const LoadingModal = ({ visible }) => (
  <Modal
    visible={visible}
    footer={null}
    closable={false}
    centered
    maskClosable={false}
  >
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spin tip="Fetching Details Please Wait..." size="large" />
    </div>
  </Modal>
);

export default LoadingModal;


// WEBPACK FOOTER //
// ./src/components/Inc/LoadingModal.js